import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=b09e8e98&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"
import style0 from "./AllNews.vue?vue&type=style&index=0&id=b09e8e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09e8e98",
  null
  
)

export default component.exports